export * from './Board';
export * from './Tiles';
export * from './MuteButton';
export * from './Score';



//////////////////
// WEBPACK FOOTER
// ./src/play/index.js
// module id = 21
// module chunks = 0